import Box from '@mui/material/Box';
import { STRATEGIC_TOOLTIP, NON_STRATEGIC_TOOLTIP } from './AppConstants';

function TooltipEntries({ entries }: { entries: [string, string][] }) {
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: theme.fuel6Tokens.JddcSpacingXSmall
      })}
    >
      {entries.map(([key, text]) => (
        <span key={key}>
          <strong>{key}</strong>: {text}
        </span>
      ))}
    </Box>
  );
}

export const StrategicTooltipContent = () => (
  <TooltipEntries entries={STRATEGIC_TOOLTIP as [string, string][]} />
);

export const NonStrategicTooltipContent = () => (
  <TooltipEntries entries={NON_STRATEGIC_TOOLTIP as [string, string][]} />
);
